/** Обновление профиля текущего пользователя. */
import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { usersKeys } from "./keys";

export const useUpdateCurrentUser = () => {
	const mutation = useMutation({
		mutationFn: Api.User.putApiUsersMe,
		mutationKey: usersKeys.updateMe,
	});

	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
